import React from 'react';
import {useTranslation} from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import WarningIcon from '@material-ui/icons/Warning';
import {FormStatus} from "../../../../models/shared";
import {TrimmedTextField} from "../../../_shared/TrimmedTextField";
import withFormItemComponentStyle from "../../../ui/styles/StyledFormItemComponent";

const InviteUserItem = ({
                            children,
                            submitted,
                            form,
                            handleFormChange,
                            handleFormDeleted,
                            classes
                        }: any) => {
    const {t} = useTranslation();
    const {data, errors} = form;
    const lockInput = form.status === FormStatus.processing || form.status === FormStatus.successful;

    const handleDeleteItem = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleFormDeleted(form.id);
    };

    const hasError = (field: any) => {
        return form.status === 'failed' || (submitted && !!errors[field])
    };

    const getTranslatedError = (errorEnum: any) => {
        if (!errorEnum) return null;
        return t(`_Common.Messages.${errorEnum}`);
    };

    let action = <IconButton aria-label="delete" className={classes.deleteBtn} onClick={handleDeleteItem}>
        <RemoveCircle/>
    </IconButton>;

    if (form.status === FormStatus.processing)
        action = <CircularProgress size={20} color="inherit"/>;
    else if (form.status === FormStatus.successful)
        action = <CheckIcon className={classes.successLabel}/>;
    else if (form.status === FormStatus.failed)
        action = <WarningIcon color='error'/>;


    return <Grid className={classes.root}>
        <TrimmedTextField
            hidden={true}
            disabled={lockInput}
            name='email'
            error={hasError('email')}
            value={data.email}
            onFormChange={(name: string, value: string) => handleFormChange(name, value, form)}
            label="Email"
            helperText={hasError('email') ? getTranslatedError(errors.email) : null}
        />
        <TrimmedTextField
            disabled={lockInput}
            name='firstName'
            error={hasError('firstName')}
            value={data.firstName}
            onFormChange={(name: string, value: string) => handleFormChange(name, value, form)}
            label="First Name"
            helperText={hasError('firstName') ? getTranslatedError(errors.firstName) : null}
        />
        <TrimmedTextField
            disabled={lockInput}
            name='lastName'
            error={hasError('lastName')}
            value={data.lastName}
            onFormChange={(name: string, value: string) => handleFormChange(name, value, form)}
            label="Last Name"
            helperText={hasError('lastName') ? getTranslatedError(errors.lastName) : null}
        />
        <div className={classes.actionContainer}>
            {
                action
            }
        </div>
        {
            children ?
                <ExpansionPanel className={classes.errorsContainer} defaultExpanded={true}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header">
                        <WarningIcon color='error'/>
                        <Typography variant='caption'>{t('Subscription.SubscriptionAssignment.EntryNeedsAttention')}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        {children}
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                : null

        }
    </Grid>
};

export const StyledInviteUserItem = withFormItemComponentStyle(InviteUserItem);
